import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.scss'],
})
export class AppLayoutComponent {
  public routeUrl = '';
  public routeClass = '';

  constructor(private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.routeUrl = event.url;
        this.setRouteClass();
      }
    });
  }

  setRouteClass() {
    if (this.routeUrl === '/pcn-details') {
      this.routeClass = 'pcn-details-layout';
    } else if (this.routeUrl === '/reasons') {
      this.routeClass = 'reasons-layout';
    }
  }
}
